import React, { Component } from 'react';
import RFIDInstance from '../../../native-interact/RFID';
import ProgressText from '../../../components/progress-text/Progress';
import { globalStore } from '../../../mobx/stores/global';

class ReadWorkMode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: 'loading',
      mode: ''
    };
  }

  componentDidMount() {
    this.init();
  }

  init() {
    RFIDInstance.readGeoWorkMode().then(() => {
      this.setState({
        status: 'success',
        mode: globalStore.modeDesc
      });
    }).catch(() => {
      this.setState({
        status: 'error'
      });
    });
  }

  render() {
    return (
      <div>
        <h4 className="popup-title">获取工作模式</h4>
        <p className="popup-p">地磁序列号：{this.props.store.RFID}</p>
        <ProgressText
          text="当前工作模式："
          success={`当前工作模式：${this.state.mode}模式`}
          error="当前工作模式：获取失败"
          status={this.state.status}
        />
      </div>
    );
  }
}

export default ReadWorkMode;
